// extracted by mini-css-extract-plugin
export default {"buttonRow":"album_buttonRow__46a8C"};